// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 6734 ? "mod-academics" : chunkId) + "." + {"6732":"ae5cbc74","6734":"b9713569"}[chunkId] + ".chunk.css";
};